import React from 'react';
import { ProgressBar } from 'primereact/progressbar';
import styles from './ChecklistProgressBar.module.scss';

interface ChecklistProgressBarProps {
  total: number;
  progress: number;
  fill?: string;
  className?: string;
}

const ChecklistProgressBar: React.FC<ChecklistProgressBarProps> = ({
  total,
  progress,
  fill = '#2F7D33',
  className,
}) => {
  const percentage = total > 0 ? (progress / total) * 100 : 100;

  return (
    <ProgressBar className={className || styles['ds-progress-bar']} showValue={false} value={percentage} color={fill} />
  );
};

export default ChecklistProgressBar;
